import React, { useState, useEffect } from 'react';
import axios from 'axios';
import TableScrollContainer from '../components/TableScrollContainer';
import './Logs.css';

function Logs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [search, setSearch] = useState('');
  const [filtroAcao, setFiltroAcao] = useState('');
  const [filtroRecurso, setFiltroRecurso] = useState('');

  const carregarLogs = async () => {
    setLoading(true);
    setErro('');
    try {
      const params = {};
      if (filtroAcao) params.acao = filtroAcao;
      if (filtroRecurso) params.recurso = filtroRecurso;
      if (search) params.q = search;

      const res = await axios.get('/api/logs', { params });
      setLogs(res.data || []);
    } catch (e) {
      setErro('Erro ao carregar histórico de auditoria.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroAcao, filtroRecurso]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    carregarLogs();
  };

  const formatarDataHora = (dataStr) => {
    if (!dataStr) return '—';
    try {
      const d = new Date(dataStr);
      return d.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    } catch (_) {
      return dataStr;
    }
  };

  const getActionBadgeClass = (acao = '') => {
    const a = acao.toUpperCase();
    if (a.includes('CRIAR') || a.includes('INSERT')) return 'badge-create';
    if (a.includes('EDITAR') || a.includes('UPDATE')) return 'badge-update';
    if (a.includes('EXCLUIR') || a.includes('DELETE')) return 'badge-delete';
    if (a.includes('LOGIN')) return 'badge-login';
    if (a.includes('CONCLUIR')) return 'badge-finish';
    return 'badge-default';
  };

  return (
    <div className="logs-page">
      <div className="logs-header">
        <div>
          <h2>📜 Histórico e Auditoria</h2>
          <p className="logs-subtitle">Rastreamento de todas as alterações, cadastros e acessos no ERP</p>
        </div>
        <div className="logs-count-badge">
          {logs.length} registro(s) encontrado(s)
        </div>
      </div>

      {erro && <div className="logs-alert logs-alert-danger">{erro}</div>}

      {/* Filtros */}
      <div className="logs-filters-card">
        <form onSubmit={handleSearchSubmit} className="logs-filters-form">
          <div className="logs-search-box">
            <span className="logs-search-icon">🔍</span>
            <input
              type="text"
              placeholder="Buscar por detalhes, nome ou usuário..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="logs-select-group">
            <select
              value={filtroAcao}
              onChange={(e) => setFiltroAcao(e.target.value)}
              className="logs-select"
            >
              <option value="">Todas as Ações</option>
              <option value="CRIAR">CRIAR</option>
              <option value="EDITAR">EDITAR</option>
              <option value="EXCLUIR">EXCLUIR</option>
              <option value="CONCLUIR">CONCLUIR</option>
              <option value="LOGIN">LOGIN</option>
            </select>

            <select
              value={filtroRecurso}
              onChange={(e) => setFiltroRecurso(e.target.value)}
              className="logs-select"
            >
              <option value="">Todos os Módulos</option>
              <option value="clientes">Clientes</option>
              <option value="agendamentos">Agendamentos</option>
              <option value="receitas">Receitas</option>
              <option value="despesas">Despesas</option>
              <option value="servicos">Serviços</option>
              <option value="usuarios">Usuários</option>
              <option value="categorias">Categorias</option>
              <option value="auth">Autenticação (Login)</option>
            </select>

            <button type="submit" className="logs-btn-filter">
              Filtrar
            </button>

            {(search || filtroAcao || filtroRecurso) && (
              <button
                type="button"
                className="logs-btn-clear"
                onClick={() => {
                  setSearch('');
                  setFiltroAcao('');
                  setFiltroRecurso('');
                  setTimeout(carregarLogs, 0);
                }}
              >
                Limpar
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Tabela de Logs */}
      <div className="logs-card">
        {loading ? (
          <div className="logs-loading">Carregando histórico de auditoria...</div>
        ) : logs.length === 0 ? (
          <div className="logs-empty">
            <span className="logs-empty-icon">📭</span>
            <p>Nenhum registro de auditoria encontrado para os filtros selecionados.</p>
          </div>
        ) : (
          <TableScrollContainer maxHeight="580px">
            <table className="logs-table">
              <thead>
                <tr>
                  <th style={{ width: '170px' }}>Data / Hora</th>
                  <th style={{ width: '160px' }}>Quem Alterou</th>
                  <th style={{ width: '110px' }}>Ação</th>
                  <th style={{ width: '130px' }}>Módulo</th>
                  <th>Detalhes da Alteração</th>
                  <th style={{ width: '120px' }}>IP</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td className="logs-date">{formatarDataHora(log.criado_em)}</td>
                    <td className="logs-user">
                      <span className="logs-user-avatar">👤</span>
                      <div>
                        <strong>{log.usuario_nome || 'Usuário'}</strong>
                        {log.usuario_login && (
                          <small className="logs-login-sub">@{log.usuario_login}</small>
                        )}
                      </div>
                    </td>
                    <td>
                      <span className={`logs-badge ${getActionBadgeClass(log.acao)}`}>
                        {log.acao}
                      </span>
                    </td>
                    <td>
                      <span className="logs-module-tag">
                        {log.recurso || 'sistema'}
                        {log.recurso_id && <small> #{log.recurso_id}</small>}
                      </span>
                    </td>
                    <td className="logs-details">{log.detalhes || '—'}</td>
                    <td className="logs-ip">{log.ip_address || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </TableScrollContainer>
        )}
      </div>
    </div>
  );
}

export default Logs;
